<template>
  <div>
    <Subheader title="Join Us" />

    <div class="app-content-column">
      <div class="card">
        <h5>Create your Mzingo Partners Profile</h5>
        <p>
          To create your Mzingo Partners profile, we need to know a little bit about you and the
          causes you care about.
        </p>
      </div>

      <div class="card">
        <h5>About You</h5>

        <form class="form" @submit.stop.prevent="registerUser">
          <FormError v-if="showFormErrors" :form-errors="formErrors" />

          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="firstName">
            <input
              v-model="userData.firstName"
              type="text"
              placeholder="First Name"
              autocomplete="given-name"
              required
            />
          </Field>

          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="lastName">
            <input
              v-model="userData.lastName"
              type="text"
              placeholder="Last Name"
              autocomplete="family-name"
              required
            />
          </Field>

          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="username">
            <input
              v-model="userData.username"
              type="text"
              autocomplete="username"
              placeholder="Username"
              required
            />
          </Field>

          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="email">
            <input v-model="userData.email" type="text" placeholder="Email" autocomplete="email" />
          </Field>

          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="password">
            <input
              v-model="userData.password"
              type="password"
              placeholder="Password"
              autocomplete="new-password"
              minlength="8"
              required
            />
          </Field>

          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="phoneNumber">
            <vue-tel-input
              v-model="userData.phoneNumber"
              wrapper-classes="tel-input"
              placeholder="Mobile Phone"
              mode="international"
              :max-len="20"
              :valid-characters-only="true"
              :required="true"
              @country-changed="countryChanged"
            ></vue-tel-input>
          </Field>

          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="zipcode">
            <input
              v-model="userData.zipcode"
              placeholder="Postal Code"
              autocomplete="postal-code"
            />
          </Field>

          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="country">
            <input
              v-model="userData.country"
              type="text"
              placeholder="Country"
              autocomplete="country-name"
              required
            />
          </Field>

          <p>
            By clicking Next, you agree to our
            <router-link :to="{ name: 'Legal', hash: '#terms-and-conditions' }" target="_blank">
              Terms & Conditions
            </router-link>
            and
            <router-link :to="{ name: 'Legal', hash: '#privacy-policy' }" target="_blank">
              Privacy policy</router-link
            >.
          </p>

          <div class="button-wrapper is-centered">
            <button type="submit" class="large-button" :disabled="loading">
              Next
            </button>
          </div>
        </form>
      </div>

      <!-- <div class="card">
        <a href="https://changefunder.org/faqs" target="_blank">FAQs</a>
        <br /><br />
      </div> -->
    </div>
  </div>
</template>

<script>
/*global fbq*/
import { VueTelInput } from 'vue-tel-input'

import Subheader from '@/components/Subheader'
import Field from '@/components/Field'
import FormError from '@/components/FormError'

import User from '@/services/users'
import { validateInputLength, validatePhoneInput } from '@/services/forms'

export default {
  name: 'UserOnboarding',
  components: {
    VueTelInput,
    Subheader,
    Field,
    FormError,
  },
  data() {
    return {
      userData: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        username: '',
        phoneNumber: '',
        zipcode: '',
        country: '',
        isMaker: true,
      },
      loading: false,
      //field errors are from client-side validation
      fieldErrors: [],
      showFieldErrors: false,
      //form errors are from server-side validation
      formErrors: [],
      showFormErrors: false,
      showLegal: false,
    }
  },
  methods: {
    async registerUser() {
      // Facebook Pixel tracking code
      fbq('track', 'CompleteRegistration')

      this.loading = true
      this.fieldErrors = this.collectFieldErrors()

      if (this.fieldErrors.length) {
        this.showFieldErrors = true
      } else {
        try {
          const response = await User.api.create(this.userData)
          this.$store.commit('UPDATE_USER', response.user)
          this.$store.commit('UPDATE_USER_TOKEN', response.token)
          this.$router.push({ name: 'ProfileSetup' })
        } catch (error) {
          const { response } = error
          if (response && response.data) {
            this.formErrors = response.data
            this.showFormErrors = true
          }
          this.loading = false
          return
        }
      }
      this.loading = false
    },
    countryChanged(countryObject) {
      if (!this.userData.country) {
        this.userData.country = countryObject.name.split('(')[0].trim()
      }
    },
    collectFieldErrors() {
      //collecting all field errors - validating length
      //exception(not required): email
      const errors = []

      Object.keys(this.userData).forEach(field => {
        if (field !== 'email' && field !== 'zipcode') {
          const error = validateInputLength(field, this.userData[field])
          if (error) {
            errors.push(error)
          }
        }
        if (field === 'phoneNumber') {
          const error = validatePhoneInput(field, this.userData[field])
          if (error) {
            errors.push(error)
          }
        }
      })

      return errors
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/cards';
@import '../styles/mixins/buttons';
@import '../styles/layout';
@import '../styles/forms';

.card {
  @include card-w-borders();
}
</style>
